import { render, staticRenderFns } from "./full-screen-centered.vue?vue&type=template&id=4455b778&scoped=true&"
import script from "./full-screen-centered.vue?vue&type=script&lang=js&"
export * from "./full-screen-centered.vue?vue&type=script&lang=js&"
import style0 from "./full-screen-centered.vue?vue&type=style&index=0&id=4455b778&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4455b778",
  null
  
)

export default component.exports